import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'

const url = 'v1/orgsys'
const plural = 'dataelements'
const single = 'dataelement'

const api = new ApiCore({
	index: true,
	findOne: false,
	findAll: false,
	create: false,
	update: false,
	remove: false,
	url: url,
	plural: plural,
	single: single
})

api.getDataElementTemplate = () => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}`)
		.then(handleResponse)
		.catch(handleError);
}

export default api
